function Stats() {
    return (
        <section className="container">
            <div className="flex space-between">
                <div className="stats-box">
                    <h4>2000+</h4>
                    <p>Happy Clients</p>
                </div>
                <div className="stats-box">
                    <h4>300+</h4>
                    <p>Stores Worldwide</p>
                </div>
                <div className="stats-box">
                    <h4>1M+</h4>
                    <p>Orders Shipped</p>
                </div>
                <div className="stats-box">
                    <h4>4.9</h4>
                    <p>Average Rating</p>
                </div>
            </div>
        </section>
    );
}

export default Stats;